module.exports = __webpack_public_path__ + "img/blue_011.c5338ac9.png";